<div class="contains-button">
  <!-- --------------------------------------------------------- TIÊU ĐỀ MỞ RỘNG --------------------------------------------------------- -->
  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate }}</span>
  </div>

  <!-- ----------------------------------------------------------- MENU CONFIG ----------------------------------------------------------- -->
  <ng-container *ngIf="!isViewAll">
    <app-position-out-config [elementChoosing]="objectChoosing" [device]="device"
      [id_parent_choose]="objectChoosing.id_block ? objectChoosing.id_block : objectChoosing.id_object">
    </app-position-out-config>

    <app-width-height-config [device]="device" [elementChoosing]="objectChoosing" [width]="class['video']['width']"
      [height]="class['video']['height']" (changeWidthHeight)="changeWidthHeight($event)">
    </app-width-height-config>


    <ul nz-menu nzMode="inline">
      <!-- KIỂU VIỀN -->
      <li nz-submenu [nzTitle]="'kieu_vien' | translate" [(nzOpen)]="openMap.menu1"
        (nzOpenChange)="openHandler('menu1')">
        <app-borders-config [device]="device" [elementChoosing]="objectChoosing" [class]="class"
          [borderClass]="class['video__iframe']" [id_object]="objectChoosing._id">
        </app-borders-config>
        <!-- Nút mở rộng -->
        <div class="item-border my-3" style="float: right; cursor: pointer;">
          <p class="m-0 title-border my-2" (click)="openViewAll(styles_field[0])">{{'mo_rong' | translate}} &#8594;</p>
        </div>
      </li>
      <!-- ẨN HIỆN -->
      <li class="p-0" nz-submenu [nzTitle]="'an_hien' | translate" [(nzOpen)]="openMap.menu2"
        (nzOpenChange)="openHandler('menu2')">
        <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
        </app-hide-show-config>
      </li>
    </ul>
  </ng-container>

  <!-- -------------------------------------------------------- CẤU HÌNH CHI TIẾT -------------------------------------------------------- -->
  <div class="view-more" *ngIf="isViewAll">
    <!-- Cấu hình chi tiết đường viền -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 1">
      <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
        [borderRadiusClass]="class['video__iframe']" [id_object]="objectChoosing._id">
      </app-borders-radius-config>
    </div>
  </div>
</div>
